import { create } from 'zustand';
import apiClient from '../utils/apiClient';

// Mutations only — the report list itself is fetched via usePaginatedList
// directly in ReportTable.jsx (server-side paginated /report-list), not
// through this store.
export const useReportsStore = create((set) => ({
  // Bumped by ReportInputTable right after a new run is submitted, so
  // ReportTable (a sibling component with its own independent 10s poll)
  // can refetch immediately instead of leaving the new run invisible in
  // Job History until its next poll tick fires.
  refreshSignal: 0,
  triggerRefresh: () => set((s) => ({ refreshSignal: s.refreshSignal + 1 })),
  cancelReport: async (reportId, userId) => {
    console.log('[reportsStore] cancelReport called for reportId:', reportId);
    try {
      await apiClient.post('/report-request', { type: 'cancel', report_id: reportId, user_id: userId });
    } catch (error) {
      console.error('[reportsStore] Failed to cancel report:', error);
      throw error;
    }
  },
  deleteReport: async (reportId, userId) => {
    console.log('[reportsStore] deleteReport called for reportId:', reportId);
    try {
      const url = userId ? `/report/${reportId}?user_id=${encodeURIComponent(userId)}` : `/report/${reportId}`;
      await apiClient.delete(url);
    } catch (error) {
      console.error('[reportsStore] Failed to delete report:', error);
      throw error;
    }
  },
}));
